<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/BarcodeStatus'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">สถานะ:</label>
                  <!-- <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control m-select2'"
                      :id="'reBsBarcodeStatusCode'"
                      :name="'reBsBarcodeStatusCode'"
                      :select2-options="reBsBarcodeStatusCodeOptions"
                      multiple
                      v-model="reBsBarcodeStatusCode"
                    ></select2> -->
                  <treeselect
                    v-model="reBsBarcodeStatusCode"
                    :multiple="true"
                    :options="reBsBarcodeStatusCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">เจ้าของทรัพย์สิน:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBsAssetOwnerId'"
                    :name="'reBsAssetOwnerId'"
                    :select2-options="reBsAssetOwnerIdOptions"
                    multiple
                    v-model="reBsAssetOwnerId"
                  ></select2> -->
                  <treeselect
                    v-model="reBsAssetOwnerId"
                    :multiple="true"
                    :options="reBsAssetOwnerIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">จังหวัด:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBsProvinceId'"
                    :name="'reBsProvinceId'"
                    :select2-options="reBsProvinceIdOptions"
                    multiple
                    v-model="reBsProvinceId"
                  ></select2> -->
                  <treeselect
                    v-model="reBsProvinceId"
                    :multiple="true"
                    :options="reBsProvinceIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div
                v-show="this.$root.canShow([''])"
                class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
              >
                <div class="form-group">
                  <label class="label">ประเภทผู้ถือครอง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBsAssetHolderType'"
                    :name="'reBsAssetHolderType'"
                    :select2-options="reBsAssetHolderTypeOptions"
                    multiple
                    v-model="reBsAssetHolderType"
                  ></select2> -->
                  <treeselect
                    v-model="reBsAssetHolderType"
                    :multiple="true"
                    :options="reBsAssetHolderTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">หมวดหมู่สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBsProductGroupId'"
                    :name="'reBsProductGroupId'"
                    :select2-options="reBsProductGroupIdOptions"
                    multiple
                    v-model="reBsProductGroupId"
                  ></select2> -->
                  <treeselect
                    v-model="reBsProductGroupId"
                    :multiple="true"
                    :options="reBsProductGroupIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBsProductTypeId'"
                    :name="'reBsProductTypeId'"
                    :select2-options="reBsProductTypeIdOptions"
                    multiple
                    v-model="reBsProductTypeId"
                  ></select2> -->
                  <treeselect
                    v-model="reBsProductTypeId"
                    :multiple="true"
                    :options="reBsProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBsProductCode'"
                    :name="'reBsProductCode'"
                    :select2-options="reBsProductCodeOptions"
                    multiple
                    v-model="reBsProductCode"
                  ></select2> -->
                  <treeselect
                    v-model="reBsProductCode"
                    :multiple="true"
                    :options="reBsProductCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset($event)"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>

              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="ExportBarcodeStatus($event)" type="submit">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="barcodeStatusTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="10">
                      ข้อมูล ณ วันที่ {{ reBsDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">สถานะ</th>
                    <th class="all text-center">เจ้าของทรัพย์สิน</th>
                    <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">ประเภทผู้ถือครอง</th>
                    <th class="all text-center">หมวดหมู่สินค้า</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-right">จำนวน</th>
                  </tr>
                </thead>
                <tfoot v-if="isShowFooter">
                  <tr style="background-color:#cdcde4">
                    <th class="all text-center" colspan="7"></th>
                    <th class="all text-center" style="color:#778ad4">
                      จำนวนรวมทั้งหมด
                    </th>
                    <th class="all text-center" style="color:#778ad4">
                      {{ TotalAmount }}
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reBsDateReq: null,
      reBsBarcodeStatusCode: [],
      reBsAssetOwnerId: [],
      reBsProvinceId: [],
      reBsAssetHolderType: [],
      reBsProductGroupId: [],
      reBsProductTypeId: [],
      reBsProductCode: [],
      TotalAmount: 0,
      isShowFooter: false,
      reBsBarcodeStatusCodeOptions: [],
      reBsIsInitial: true,
      // reBsBarcodeStatusCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsAssetOwnerIdOptions: [],
      // reBsAssetOwnerIdOptions: {
      //   placeholder: "กรุณาเลือกเจ้าของทรัพย์สิน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterAssetOwner/Select2AssetOwner",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsProvinceIdOptions: [],
      // reBsProvinceIdOptions: {
      //   placeholder: "กรุณาเลือกจังหวัด",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchProvince",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         department: [],
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsAssetHolderTypeOptions: [
        { id: "ตัวแทนจำหน่าย", label: "ตัวแทนจำหน่าย" },
        { id: "โรงงาน/คลัง", label: "โรงงาน/คลัง" },
        { id: "ตัวแทนจำหน่ายย่อย", label: "ตัวแทนจำหน่ายย่อย" },
        { id: "ร้านค้า", label: "ร้านค้า" },
        { id: "ซัพพลายเออร์", label: "ซัพพลายเออร์" },
        { id: "ร้านค้าของตัวแทนฯย่อย", label: "ร้านค้าของตัวแทนฯย่อย" },
      ],
      // reBsAssetHolderTypeOptions: {
      //   placeholder: "กรุณาเลือกประเภทผู้ถือครอง",
      //   allowClear: true,
      //   data: [
      //     { id: "ตัวแทนจำหน่าย", text: "ตัวแทนจำหน่าย" },
      //     { id: "โรงงาน/คลัง", text: "โรงงาน/คลัง" },
      //     { id: "ตัวแทนจำหน่ายย่อย", text: "ตัวแทนจำหน่ายย่อย" },
      //     { id: "ร้านค้า", text: "ร้านค้า" },
      //     { id: "ซัพพลายเออร์", text: "ซัพพลายเออร์" },
      //     { id: "ร้านค้าของตัวแทนฯย่อย", text: "ร้านค้าของตัวแทนฯย่อย" },
      //   ],
      // },
      reBsProductGroupIdOptions: [],
      // reBsProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsProductTypeIdOptions: [],
      // reBsProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBsProductCodeOptions: [],
      // reBsProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;

      self.reBsBarcodeStatusCode = [];
      self.reBsAssetOwnerId = [];
      self.reBsProvinceId = [];
      self.reBsAssetHolderType = [];
      self.reBsProductGroupId = [];
      self.reBsProductTypeId = [];
      self.reBsProductCode = [];

      $("#reBsBarcodeStatusCode")
        .val("")
        .trigger("change");

      $("#reBsAssetOwnerId")
        .val("")
        .trigger("change");

      $("#reBsProvinceId")
        .val("")
        .trigger("change");

      $("#reBsAssetHolderType")
        .val("")
        .trigger("change");

      $("#reBsProductGroupId")
        .val("")
        .trigger("change");

      $("#reBsProductTypeId")
        .val("")
        .trigger("change");

      $("#reBsProductCode")
        .val("")
        .trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function(e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reBsIsInitial = true;
      }
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      e.preventDefault();
      var table = $("#barcodeStatusTable").DataTable();
      table.draw();
    },
    LoadreBsBarcodeStatusCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBsBarcodeStatusCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBsAssetOwnerIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterAssetOwner/Select2AssetOwner", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBsAssetOwnerIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBsProvinceIdOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchProvince", {
          department: [],
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBsProvinceIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBsProductGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductGroup/Select2ProductGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBsProductGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBsProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBsProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBsProductCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBsProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ExportBarcodeStatus: function (e) {
      e.preventDefault();
      let self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportBarcodeStatus",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reBsIsInitial,
          BarcodeStatusCode: self.reBsBarcodeStatusCode,
          AssetOwnerId: self.reBsAssetOwnerId,
          ProvinceId: self.reBsProvinceId,
          AssetHolderType: self.reBsAssetHolderType,
          ProductGroupId: self.reBsProductGroupId,
          ProductTypeId: self.reBsProductTypeId,
          ProductCode: self.reBsProductCode,
          CurrentAgentCode: [],
          CurrentSubShopId: [],
          CurrentPlantCode: [],
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;

    self.LoadreBsBarcodeStatusCodeOptions();
    self.LoadreBsAssetOwnerIdOptions();
    self.LoadreBsProvinceIdOptions();
    self.LoadreBsProductGroupIdOptions();
    self.LoadreBsProductTypeIdOptions();
    self.LoadreBsProductCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reBsDateReq = moment().format("DD/MM/YYYY h:mm a");
    
    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#barcodeStatusTable");
    //begin first table
    table
      .DataTable({
        paging: false,
        autoWidth: true,
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/BarcodeStatus",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            self.isShowFooter = false;
            self.TotalAmount = 0;

            let jsonSearch = {
              IsInitial: self.reBsIsInitial,
              BarcodeStatusCode: self.reBsBarcodeStatusCode,
              AssetOwnerId: self.reBsAssetOwnerId,
              ProvinceId: self.reBsProvinceId,
              AssetHolderType: self.reBsAssetHolderType,
              ProductGroupId: self.reBsProductGroupId,
              ProductTypeId: self.reBsProductTypeId,
              ProductCode: self.reBsProductCode,
              CurrentAgentCode: [],
              CurrentSubShopId: [],
              CurrentPlantCode: [],
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        orderFixed: [0, "desc"],
        //order: [[0, "desc"]],
        columns: [
          { data: "barcodeStatusName", className: "text-center" },
          { data: "assetOwnerName", className: "text-center" },
          {
            data: "provinceId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return full.provinceName;
            },
          },
          { data: "assetHolderType", className: "text-center" },
          { data: "productGroupName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "productCode", className: "text-center" },
          { data: "productName", className: "text-center" },
          {
            data: "totalBarcodes",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
        ],
        rowCallback: function(row, data, index) {
          if (data.barcodeStatusName == null) {
            $(row)
              .find("td:eq(7)")
              .css("font-weight", "bold");
            $(row)
              .find("td:eq(7)")
              .css("color", "#93a2dd");
            $(row)
              .find("td:eq(8)")
              .css("font-weight", "bold");
            $(row)
              .find("td:eq(8)")
              .css("color", "#93a2dd");
            $(row).css("background-color", "#e1e1ef");
          }
        },
        drawCallback: function(settings) {
          self.reBsDateReq = moment().format("DD/MM/YYYY h:mm a");
          self.reBsIsInitial = false;

          if (settings.json.recordsTotal > 0) {
            var totalAmount = settings.json.data[0].grandTotalBarcodes;
            self.isShowFooter = true;
            self.TotalAmount =
              totalAmount != null || totalAmount != "" || data !== 0
                ? totalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : "";
            $.fn.dataTable
              .tables({ visible: true, api: true })
              .columns.adjust();
          }
          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/BarcodeStatus.vue